// extracted by mini-css-extract-plugin
export default {"spinner":"PurchaseSidebar-module__spinner___O-thY","scrollArea":"PurchaseSidebar-module__scrollArea___KLwxp"};